import PropTypes from 'prop-types';
import React from 'react';
import './MessageDocumentsInfo.styles.scss';

const MessageDocumentsInfo = (props) => {
  return (
    <div className="message-line" data-testid="message-received">
      <div
        className="message-receive"
        id={`msg-${props.message.id}`}
        data-aut-test="message-receive-info-document"
        data-testid="message-receive-info-document"
      >
        <div className="message-div">
          <ul className="style-list">
            <li>Endereço;</li>
            <li>Sócios;</li>
            <li>Dados referentes ao CNPJ;</li>
            <li>
              Código de afiliação da maquininha contratada para habilitar nossos
              produtos.
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

MessageDocumentsInfo.propTypes = {
  message: PropTypes.object
};

export default MessageDocumentsInfo;
